export const FeatureSetWebTerminal: string = 'web_terminal'
